import { createSlice } from "@reduxjs/toolkit";
import { AR_MARKUP_VIEW, FONT_SIZE, MARKUP_VIEW, SHAPE_THICKNESS, SHAPE_TYPE } from "../constants/Constants";

const initialState = {
    selectedThicknessForShape: SHAPE_THICKNESS[5], // 10px
    selectedFontSizeForShape: FONT_SIZE[7], // 30px
    selectedShapeType: SHAPE_TYPE.FREEDRAW,
    selectedColorIndex: 0,
    isShadowOrStroke: true,
    allShapeDisable: false,
    undoEnabled: false,
    redoEnabled: false,
    clearMarkup: false,
    /* markup */
    markupInprogress: MARKUP_VIEW.OFF_VIEW,
    continueMarkup: false,
    markupLiveStream: false,
    arMarkupLiveStream: AR_MARKUP_VIEW.OFF_VIEW,
    arMarkupStatusPopup: false,
    arMarkupToastMsgStatus: null,
    assignedColors: {},
    callannview: false,
    savebtndisabled: true,
    annPointlength: 0,
    confirmExitMarkup: false,
};

const markupReducerSlice = createSlice({
    name: "commonReducer",
    initialState,
    reducers: {
        setSelectedThicknessForShape(state, action) {
            state.selectedThicknessForShape = action.payload;
        },
        setSelectedShapeType(state, action) {
            state.selectedShapeType = action.payload;
        },
        setSelectedFontSizeForShape(state, action) {
            state.selectedFontSizeForShape = action.payload;
        },
        setSelectedColorIndex(state, action) {
            state.selectedColorIndex = action.payload;
        },
        setIsShadowOrStroke(state, action) {
            state.isShadowOrStroke = action.payload;
        },
        setAllShapeDisable(state, action) {
            state.allShapeDisable = action.payload;
        },
        setUndoEnabled(state, action) {
            state.undoEnabled = action.payload;
        },
        setRedoEnabled(state, action) {
            state.redoEnabled = action.payload;
        },
        setClearMarkup(state, action) {
            state.clearMarkup = action.payload;
        },
        setMarkupInprogress(state, action) {
            state.markupInprogress = action.payload;
        },
        setContinueMarkup(state, action) {
            state.continueMarkup = action.payload;
        },
        setMarkupLiveStream(state, action) {
            state.markupLiveStream = action.payload;
        },
        setARmarkupLiveStream(state, action) {
            state.arMarkupLiveStream = action.payload;
        },
        setARMarkupStatusPopup(state, action) {
            state.arMarkupStatusPopup = action.payload;
        },
        setARMarkupToastMsgStatus(state, action) {
            state.arMarkupToastMsgStatus = action.payload;
        },
        setAssignedColors(state, action) {
            state.assignedColors = action.payload;
        },
        setCallannview(state, action) {
            state.callannview = action.payload;
        },
        setSavebtndisabled(state, action) {
            state.savebtndisabled = action.payload;
        },
        setAnnPointlength(state, action) {
            state.annPointlength = action.payload;
        },
        setConfirmExitMarkup(state, action) {
            state.confirmExitMarkup = action.payload;
        },
        resetMarkupReducer() {
            return initialState;
        },
    },
});

export const {
    setSelectedThicknessForShape,
    setSelectedShapeType,
    setSelectedFontSizeForShape,
    setSelectedColorIndex,
    setIsShadowOrStroke,
    setAllShapeDisable,
    setUndoEnabled,
    setRedoEnabled,
    setClearMarkup,
    setMarkupInprogress,
    setContinueMarkup,
    setMarkupLiveStream,
    setARmarkupLiveStream,
    setARMarkupStatusPopup,
    setARMarkupToastMsgStatus,
    setAssignedColors,
    setCallannview,
    setSavebtndisabled,
    resetMarkupReducer,
    setAnnPointlength,
    setConfirmExitMarkup,
} = markupReducerSlice.actions;
export default markupReducerSlice.reducer;
